import axios from 'axios';
import { SERVER_URL } from '../../../helpers/Config';
import { removeEmailToken } from '../../../helpers/EmailToken';
import { history } from '../../../history';
import { setToken } from '../../../helpers/Token';
import { emitGAEvent } from '../../../helpers/GoogleAnalytics';

export const checkEmailToken = (data) => {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_EMAIL_TOKEN_STATE',
      payload: {
        emailToken: data.emailToken,
        isLoading: true,
      },
    });
    axios
      .post(SERVER_URL + 'persons/check-password-token', {
        token: data.emailToken,
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          const email = response.data.data.email;
          if (!email) {
            dispatch({
              type: 'UPDATE_EMAIL_TOKEN_STATE',
              payload: {
                emailToken: null,
                isValid: false,
                isLoading: false,
              },
            });
            removeEmailToken();
            return;
          }
          dispatch({
            type: 'UPDATE_EMAIL_TOKEN_STATE',
            payload: {
              email,
              isValid: true,
              isLoading: false,
            },
          });
          dispatch({
            type: 'TOAST',
            payload: {
              text: 'Welcome, please create your password to continue',
              type: 'success',
            },
          });
          history.replace('/reset-password');
        } else {
          dispatch({
            type: 'UPDATE_EMAIL_TOKEN_STATE',
            payload: {
              emailToken: null,
              isValid: false,
              isLoading: false,
            },
          });
          removeEmailToken();
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: 'UPDATE_EMAIL_TOKEN_STATE',
          payload: {
            emailToken: null,
            isValid: false,
            isLoading: false,
          },
        });
        removeEmailToken();
      });
  };
};

export const resetPasswordWithEmailToken = (data) => {
  return (dispatch) => {
    axios
      .post(SERVER_URL + 'persons/reset-password', {
        token: data.token,
        password: data.password,
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          const loggedInUser = response.data.data.token;
          removeEmailToken();
          dispatch({
            type: 'UPDATE_EMAIL_TOKEN_STATE',
            payload: {
              emailToken: null,
              isValid: false,
              isLoading: false,
            },
          });
          setToken(loggedInUser);
          dispatch({
            type: 'LOGIN_WITH_JWT',
            payload: { loggedInUser, loggedInWith: 'jwt' },
          });
          dispatch({
            type: 'TOAST',
            payload: {
              text: 'Your password is created, welcome!',
              type: 'success',
            },
          });
          const initialPath = window.initialPath || '/';
          history.replace(initialPath);
          const method = initialPath.includes('proposals')
            ? 'Proposal E-Mail Link'
            : initialPath.includes('projects')
            ? 'Project E-Mail Link'
            : 'Other';
          emitGAEvent('sign_up', {
            method: method,
            initialPath: initialPath,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
